var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from "semantic-ui-react";
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { priceColumn } from "../rna-fish/EditKitForm";
import { ComponentPriceDisplay } from "../rna-fish/ProbeSetForm";
import { getSecondaryIfProbeCatalog } from "./SecondaryIfCatalog";
var ProbeForm = /** @class */ (function (_super) {
    __extends(ProbeForm, _super);
    function ProbeForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onCustomPriceChange = function (newStateFn, callback) {
            var _a;
            _this.props.onProbeChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, (_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier, callback);
        };
        _this.onProbeChange = function (_, data) {
            var _a;
            var probe = getSecondaryIfProbeCatalog(_this.props.legacy, _this.props.catalog).probes.find(function (p) { return p.id === data.value; });
            if (probe === undefined) {
                throw new RangeError("Could not find probe " + data.value);
            }
            // assume first amplifier is the default
            var probeAmplifier = probe.amplifiers[0];
            _this.props.onProbeChange({ probeAmplifier: probeAmplifier }, (_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier, _this.props.onUserSelection);
        };
        _this.onAmplifierChange = function (_, data) {
            var _a;
            if (typeof data.value !== 'number') {
                throw new TypeError("Selected value is not a number: " + typeof data.value);
            }
            var prevAmplifier = (_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier;
            var probe = getSecondaryIfProbeCatalog(_this.props.legacy, _this.props.catalog).probesByAmplifierId.get(data.value);
            if (probe === undefined) {
                throw new RangeError("Could not find probe amplifier " + data.value);
            }
            var probeAmplifier = probe.amplifiers.find(function (pa) { return pa.id === data.value; });
            if (probeAmplifier === undefined) {
                throw new Error("Apparently valid probe argument id wasn't");
            }
            _this.props.onProbeChange({ probeAmplifier: probeAmplifier }, prevAmplifier, _this.props.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var _a;
            var scale = getSecondaryIfProbeCatalog(_this.props.legacy, _this.props.catalog).scales.find(function (s) { return s.ugram === data.value; });
            if (scale === undefined) {
                throw new RangeError("Could not find scale " + data.value);
            }
            _this.props.onProbeChange({ scale: scale }, (_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.amplifier, _this.props.onUserSelection);
        };
        /**
         * @return a Probe if the probe amplifier id is set and valid, else undefined
         */
        _this.currentProbe = function () {
            var _a;
            var id = (_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.id;
            if (id !== undefined) {
                return getSecondaryIfProbeCatalog(_this.props.legacy, _this.props.catalog).probesByAmplifierId.get(id);
            }
            return undefined;
        };
        return _this;
    }
    ProbeForm.prototype.render = function () {
        var _this = this;
        var _a;
        var probeLabel = React.createElement(React.Fragment, null,
            this.props.legacy ? "2º Antibody Probe" : "Host & reactivity",
            " ",
            React.createElement(Help, null,
                React.createElement("p", null,
                    "Select the ",
                    this.props.legacy ? "" : "HCR™ HiFi",
                    " 2\u00BA Antibody Probe for your experiment. For example, if your primary antibody was raised in rabbit, select \u201CDonkey Anti-Rabbit\u201D; if your primary antibody was raised in mouse, select \u201CDonkey Anti-Mouse\u201D."),
                React.createElement("p", null,
                    "For multiplex experiments, choose a different ",
                    this.props.legacy ? "" : "HCR™ HiFi",
                    " 2\u00BA Antibody Probe for each target that will be imaged in the same sample (for example, \u201CDonkey Anti-Rabbit\u201D for target 1, \u201CDonkey Anti-Mouse\u201D for target 2, ...).")));
        var legacyAmpLabel = React.createElement(React.Fragment, null,
            "For use with amplifier ",
            React.createElement(Help, null, "Specify the HCR\u2122 Amplifier (v3.0) that you will use with your probe. For multiplex experiments, choose a different HCR\u2122 Amplifier (v3.0) (B1, B2, ...) for each target that will be imaged in the same sample (for example, amplifier B1 for target 1, amplifier B2 for target 2, ...)."));
        var goldAmpLabel = React.createElement(React.Fragment, null,
            "For use with amplifier ",
            React.createElement(Help, null,
                React.createElement("p", null, "Specify the HCR\u2122 Gold Amplifier that you will use with your HCR\u2122 HiFi 2\u02DA Antibody Probe. For multiplex experiments, choose a different HCR\u2122 Gold Amplifier (X1, X2, \u2026) for each target that will be imaged in the same sample (for example, amplifier X1 for target 1, amplifier X2 for target 2, \u2026)."),
                React.createElement("p", null, "For flexibility, 488, 546, 594, and 647 are available across all X1-X10 systems. For expanded channel options, select amplifiers also offer an additional unique label option. We recommend using a longer-wavelength label (e.g., 647 or 750) for targets that are more difficult to detect (e.g., low-expression targets), as autofluorescence tends to be higher in shorter-wavelength channels (e.g., 405 or 488).")));
        var legacyScaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "The standard reaction concentration of an HCR\u2122 2\u00BA Antibody Probe is 1 \u03BCg/mL. The 2\u00BA antibody scale depends on the reaction volume and the number of experiments. For example, for a 100 \u03BCL reaction volume, each experiment will require 0.1 \u03BCg of probe, so 10 \u03BCg probe scale corresponds to 100 experiments. For the following sample types, reaction volumes are:",
                React.createElement("p", null),
                ProbeForm.experimentVolumeTable));
        var goldScaleLabel = React.createElement(React.Fragment, null,
            "Scale ",
            React.createElement(Help, null,
                "HCR\u2122 HiFi 2\u02DA Antibody Probe is provided at a scale of 10 \u00B5g in 20 \u00B5L corresponding to a concentration of 0.5 mg/mL. For different sample types, representative reaction volumes and corresponding probe scale and number of experiments are:",
                React.createElement("p", null),
                ProbeForm.goldExperimentVolumeTable));
        var selectedProbe = this.currentProbe();
        // linear lookup but it's a small list
        var selectedProbeAmplifier = (_a = selectedProbe === null || selectedProbe === void 0 ? void 0 : selectedProbe.amplifiers) === null || _a === void 0 ? void 0 : _a.find(function (pa) { var _a; return pa.id === ((_a = _this.props.probeState.probeAmplifier) === null || _a === void 0 ? void 0 : _a.id); });
        var probeOptions = getSecondaryIfProbeCatalog(this.props.legacy, this.props.catalog).probes.map(function (p) { return ({
            text: p.name,
            value: p.id
        }); });
        var ampOptions = [];
        if (selectedProbe !== undefined) {
            ampOptions = ampOptions.concat(selectedProbe.amplifiers.map(function (a) { return ({
                text: a.amplifier.id,
                value: a.id
            }); }));
        }
        var scaleOptions = getSecondaryIfProbeCatalog(this.props.legacy, this.props.catalog).scales.map(function (s) {
            var numberOfSamples = calculateNumOfSamplesForProbe(s.ugram);
            var numberOfSlides = calculateNumOfSlidesForProbe(s.ugram);
            var volumeLabel = s.valueWithUnit();
            return displayScaleLabel(s.ugram, numberOfSamples, numberOfSlides, volumeLabel, _this.props.selectedSampleType);
        });
        var noProbeSelected = selectedProbe === undefined;
        return React.createElement(Grid, { columns: 4, stackable: true },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: "/probeComponent/probe/catalogEntry/id", errors: this.props.errors, labelContent: probeLabel, labelFor: 'probeId', showErrors: this.props.showErrors },
                        React.createElement(Select, { name: 'probeId', options: probeOptions, onChange: this.onProbeChange, placeholder: 'Select...', search: true, value: selectedProbe === null || selectedProbe === void 0 ? void 0 : selectedProbe.id }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: noProbeSelected, errorPath: "/probeComponent/scaleUgram", errors: this.props.errors, labelContent: this.props.legacy ? legacyScaleLabel : goldScaleLabel, labelFor: 'scale', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: this.props.legacy ? 'deactivated-dropdown' : 'label-dropdown', name: 'scale', icon: this.props.legacy ? false : undefined, options: scaleOptions, onChange: this.onScaleChange, search: false, value: this.props.probeState.scale.ugram })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { disabled: noProbeSelected, errorPath: "/probeComponent/probe/catalogEntry/id", errors: this.props.errors, labelContent: this.props.legacy ? legacyAmpLabel : goldAmpLabel, labelFor: 'amplifier', showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "label-dropdown amp-dropdown", disabled: this.props.amplifierDropdownDisabled, name: 'amplifier', options: ampOptions, onChange: this.onAmplifierChange, search: true, value: selectedProbeAmplifier === null || selectedProbeAmplifier === void 0 ? void 0 : selectedProbeAmplifier.id }))),
                React.createElement(Grid.Column, null),
                React.createElement(Grid.Column, null),
                priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents)),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.probeState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/probeComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    // first column of ihc2 buffers volume table
    ProbeForm.experimentVolumeTable = React.createElement(Table, { celled: true, className: 'exp-volume-table', striped: true },
        React.createElement(Table.Header, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.HeaderCell, null, "Sample type"),
                React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"))),
        React.createElement(Table.Body, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Whole-mount zebrafish embryos (28 hpf)"),
                React.createElement(Table.Cell, null, "250")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "FFPE tissue section"),
                React.createElement(Table.Cell, null, "100")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Mammalian cells on a slide"),
                React.createElement(Table.Cell, null, "300")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample in solution"),
                React.createElement(Table.Cell, null, "250")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample on a slide"),
                React.createElement(Table.Cell, null, "100"))));
    ProbeForm.goldExperimentVolumeTable = React.createElement(Table, { celled: true, striped: true },
        React.createElement(Table.Header, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.HeaderCell, null, "Sample type"),
                React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi 2\u02DA Antibody Probe (\u00B5L)"),
                React.createElement(Table.HeaderCell, null, "Experiments"))),
        React.createElement(Table.Body, null,
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                React.createElement(Table.Cell, null, "100"),
                React.createElement(Table.Cell, null, "0.2"),
                React.createElement(Table.Cell, null, "100")),
            React.createElement(Table.Row, null,
                React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo or cells in suspension)"),
                React.createElement(Table.Cell, null, "200"),
                React.createElement(Table.Cell, null, "0.4"),
                React.createElement(Table.Cell, null, "50"))));
    return ProbeForm;
}(React.PureComponent));
export default ProbeForm;
export var displayScaleLabel = function (value, numberOfSamples, numberOfSlides, volumeLabel, selectedSampleType) {
    if (selectedSampleType.id === 'WHOLE_MOUNT' || selectedSampleType.id === 'CELLS_SUSPENSION') {
        return {
            text: React.createElement(React.Fragment, null,
                numberOfSamples,
                " samples",
                React.createElement("span", { className: "description" }, volumeLabel)),
            content: React.createElement(React.Fragment, null,
                numberOfSamples,
                " samples",
                React.createElement("span", { className: "description" }, volumeLabel)),
            value: value
        };
    }
    else if (selectedSampleType.id === 'TISSUE_SECTION' || selectedSampleType.id === 'CELLS_SLIDE') {
        return {
            text: React.createElement(React.Fragment, null,
                numberOfSlides,
                " slides",
                React.createElement("span", { className: "description" }, volumeLabel)),
            content: React.createElement(React.Fragment, null,
                numberOfSlides,
                " slides",
                React.createElement("span", { className: "description" }, volumeLabel)),
            value: value
        };
    }
    else {
        return {
            text: React.createElement(React.Fragment, null, volumeLabel),
            content: React.createElement(React.Fragment, null, volumeLabel),
            value: value
        };
    }
};
export var displayScaleLabelForCart = function (numberOfSamples, numberOfSlides, volumeLabel, selectedSampleType) {
    if (selectedSampleType.id === 'WHOLE_MOUNT' || selectedSampleType.id === 'CELLS_SUSPENSION') {
        return numberOfSamples + " samples" + (volumeLabel.length > 0 ? " (" + volumeLabel + ")" : "");
    }
    else if (selectedSampleType.id === 'TISSUE_SECTION' || selectedSampleType.id === 'CELLS_SLIDE') {
        return numberOfSlides + " slides" + (volumeLabel.length > 0 ? " (" + volumeLabel + ")" : "");
    }
    else {
        return "" + volumeLabel;
    }
};
export var calculateNumOfSamplesForProbe = function (ugram) {
    return ugram * 5;
};
export var calculateNumOfSlidesForProbe = function (ugram) {
    return ugram * 10;
};
//# sourceMappingURL=ProbeForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/secondary-if/ProbeForm.js
// module id = 323
// module chunks = 0